import React from "react";

/**
 * Dark section: heading + rows of image (optional dim overlay + centered logo) + copy.
 * @param {string} title — Section heading.
 * @param {{ imageSrc: string, imageAlt?: string, title: string, description: string, id?: string, logo?: React.ReactNode }[]} items
 * @param {string} className — Optional section classes.
 */
export default function ParticipatingRestaurants({
  title = "Participating Restaurants",
  items = [],
  className = "",
}) {
  if (!items.length) return null;

  return (
    <section
      className={`bg-ink text-white ${className}`.trim()}
      aria-labelledby="participating-restaurants-heading"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-12 py-12 md:py-16 lg:py-20">
        <h2
          id="participating-restaurants-heading"
          className="text-2xl md:text-3xl font-bold font-sf-pro-display tracking-tight text-white mb-10 md:mb-14 lg:mb-16"
        >
          {title}
        </h2>

        <ul className="m-0 p-0 list-none flex flex-col gap-12 md:gap-16 lg:gap-20">
          {items.map((item, index) => (
            <li
              key={item.id ?? `restaurant-${index}`}
              className="flex flex-col md:flex-row md:items-start gap-6 md:gap-10 lg:gap-12"
            >
              <div className="relative w-full md:w-[346px] md:flex-shrink-0 overflow-hidden bg-neutral-900 aspect-[346/229]">
                <img
                  src={item.imageSrc}
                  alt={item.imageAlt ?? ""}
                  className="absolute inset-0 block w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
                {item.logo ? (
                  <>
                    <div
                      className="absolute inset-0 bg-[#0000008C]"
                      aria-hidden
                    />
                    <div className="absolute inset-0 flex items-center justify-center p-4 text-center text-white pointer-events-none">
                      <div className="w-full max-w-[300px] flex flex-col items-center justify-center">
                        {item.logo}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
              <div className="flex flex-col justify-center min-w-0 flex-1 pt-0 md:pt-1">
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4 font-sf-pro-display leading-snug">
                  {item.title}
                </h3>
                <p className="m-0 text-sm md:text-base leading-relaxed text-white/60 max-w-3xl">
                  {item.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
